import React from "react";
import classNames from "classnames";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { isArray, isUndefined } from "lodash";

import Help from "../Help";
import {
  importNumWithComma,
  exportNumWithDot,
  isLogged,
  isPublic,
  isNotLogged,
} from "../../CroUtils";
import { FormattedMuiInput } from "../../../../components/form/Input";

const isRequired = ({ validate }) =>
  isArray(validate)
    ? validate.some((fun) => fun.croName === "required")
    : false;

const required = (auth, fieldRest) =>
  (isNotLogged(auth) && !fieldRest.disabled) ||
  (isLogged(auth) && isPublic(auth) && !fieldRest.disabled) ||
  (isLogged(auth) && !isPublic(auth));

const CroPriceField = ({
  className,
  title,
  labelStyle,
  helpEnum,
  component,
  auth,
  ...fieldRest
}) => (
  <label className={className}>
    <span className="title-row">
      <span
        className={classNames("title", {
          required: isRequired(fieldRest) && required(auth, fieldRest),
        })}
        style={labelStyle}
      >
        {title}
      </span>
      {!isUndefined(helpEnum) && (
        <span className="help-icon title-help-icon">
          <Help helpEnum={helpEnum} disabled={fieldRest.disabled} />
        </span>
      )}
    </span>
    <div className="croPriceField__row">
      <div className="croPriceField__input">
        <Field
          {...fieldRest}
          normalize={exportNumWithDot}
          format={importNumWithComma}
          component={FormattedMuiInput}
          thousandSeparator={" "}
          isNumericString={true}
          decimalSeparator={","}
        />
      </div>
      <span className="croPriceField__currency">Kč</span>
    </div>
  </label>
);

const mapStateToProps = (state) => ({
  auth: state.sidebar.auth,
});

export default connect(mapStateToProps)(CroPriceField);
